import {DecarbonizationType, DecarbonizationTypeRegion} from "./decarbonization.model";

export class FuelType extends DecarbonizationType {

  public static fromDto(ft): FuelType {
    if (ft == null) {
      return null;
    }

    const fuelType = new FuelType();
    fuelType.id = ft.id;
    fuelType.label = ft.label;
    return fuelType;
  }
}

export class FuelTypeRegion extends DecarbonizationTypeRegion {

  public fuelTypeId: string;

  public static fromDto(ft): FuelTypeRegion {
    if (ft == null) {
      return null;
    }

    const fuelTypeRegion = new FuelTypeRegion();
    fuelTypeRegion.id = ft.id;
    fuelTypeRegion.fuelTypeId = ft.fuel_type_id;
    fuelTypeRegion.regionId = ft.region_id;
    fuelTypeRegion.label = ft.label;
    return fuelTypeRegion;
  }
}
